export const occc = {
    agencyCode: '466',
    name: 'Office of Consumer Credit Commissioner',
    shortName: 'OCCC',
    slug: 'occc',
  };
  